module.exports = __webpack_public_path__ + "img/weprotectprivacy.8d0166a0.png";